import type { FC } from 'react';

import { EndStepCard, EndStepCardProps } from '@eneco/components/flow/EndStep/Card';
import { EndStepHero, EndStepHeroProps } from '@eneco/components/flow/EndStep/EndStepHero';
import { Iconlist } from '@eneco/flows/components';
import { CheckIcon, ClockIcon } from '@eneco/sparky/icons';

interface Props extends EndStepCardProps, EndStepHeroProps {
  nextStepList?: { label: string; state: number }[];
}

export const Simple: FC<Props> = ({
  heroImage,
  title,
  content,
  buttonHref,
  buttonText,
  textLinkText,
  textLinkHref,
  textLinkAction,
  nextStepList,
}) => {
  return (
    <EndStepHero heroImage={heroImage}>
      <EndStepCard
        title={title}
        content={content}
        buttonHref={buttonHref}
        buttonText={buttonText}
        textLinkText={textLinkText}
        textLinkHref={textLinkHref}
        textLinkAction={textLinkAction}>
        {nextStepList?.length && (
          <Iconlist gap="4">
            <>
              {nextStepList.map(listItem => (
                <Iconlist.Item
                  key={listItem.label}
                  gap="1"
                  icon={
                    listItem.state === 0 ? <CheckIcon color="feedbackSuccess" /> : <ClockIcon color="currentColor" />
                  }>
                  {listItem.label}
                </Iconlist.Item>
              ))}
            </>
          </Iconlist>
        )}
      </EndStepCard>
    </EndStepHero>
  );
};
